var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function Svg(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "\xE6\xB5\x81\xE5\x90\x91",
    clipPath: "url(#clip0_86_1897)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M15.6142 7.46017L11.5769 5.12999C11.0625 4.83311 10.6416 5.06223 10.6416 5.63934L10.6416 6.95082L5.09066 6.95082C4.48835 6.95082 4 7.42059 4 7.99999C4 8.57941 4.48835 9.04917 5.09066 9.04917L10.6416 9.04917L10.6416 10.3606C10.6416 10.9378 11.0625 11.1669 11.5769 10.87L15.6142 8.53984C16.1286 8.24296 16.1286 7.75705 15.6142 7.46017Z",
    fill: "#FE545F"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle 163",
    x: 1,
    y: 2,
    width: 2,
    height: 12,
    rx: 1,
    fill: "#FE545F"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_86_1897"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(Svg);
export default __webpack_public_path__ + "static/media/流向.af37b625d1019087e36e4d1f938d17a5.svg";
export { ForwardRef as ReactComponent };